import { useEffect, useState } from "react";
import Translation from "libs/Translation";
import Text from "components/common/Text";
import Image from "next/image";
import MedicalTeamCard from "./MedicalTeamCard";
import Loader from "components/common/DotLoader";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import SearchInput from "../../common/SearchInput";

const MedicalTeam = ({
  medicalTeamList,
  loading,
  center,
  mobileView,
  webConfig,
  inModal,
  externalSearchTerm = "",
  onSearchChange,
}) => {
  const [viewMore, setViewMore] = useState();
  const [medicalTeam, setMedicalTeam] = useState(medicalTeamList);

  useEffect(() => {
    setViewMore(inModal);
  }, [inModal]);

  useEffect(() => {
    if (medicalTeam?.length <= 3) setViewMore(true);
  }, [medicalTeam]);

  useEffect(() => {
    setMedicalTeam(medicalTeamList);
  }, [medicalTeamList]);

  const normalizedSearch = externalSearchTerm.trim().toLowerCase();
  const searchWords = normalizedSearch
    .split(/\s+/)
    .filter((word) => word.length > 1 && word !== "و");

  const isSearching = searchWords.length > 0;

  const filteredMedicalTeam = !isSearching
    ? medicalTeam
    : medicalTeam?.filter((doctor) => {
        if (!doctor) return false;

        const doctorDataString = [
          doctor.FirstName,
          doctor.LastName,
          doctor.FullName,
          doctor.FormalName,
          ...(doctor.Specialties || []).map((s) => s?.Specialty),
          ...(doctor.HealthWorkerProfiles || []).flatMap((p) =>
            (p?.Specialties || []).map((s) => s?.Name || s?.Label)
          ),
        ]
          .filter(Boolean)
          .join(" ")
          .toLowerCase();

        return searchWords.every((word) => doctorDataString.includes(word));
      });

  const displayMedicalTeam = isSearching
    ? filteredMedicalTeam
    : viewMore
    ? medicalTeam
    : medicalTeam?.slice(0, 3);

  const containerStyle =
    inModal || isSearching
      ? { height: "auto" }
      : medicalTeam?.length <= 3
      ? {
          height: `${
            233 * medicalTeam?.length + 17 * (medicalTeam?.length - 1)
          }px`,
        }
      : viewMore
      ? { height: "1233px" }
      : { height: "733px" };

  return (
    <>
      {loading ? (
        <div className="loading">
          <Loader size={13} color="gray" />
        </div>
      ) : medicalTeam?.length ? (
        <div className="box padding-24">
          <div className="row-flex flex-title">
            <Image
              src="/nextasset/images/center/icon-5.png"
              width={mobileView ? 28 : 32}
              height={mobileView ? 28 : 32}
              alt="text-icon"
            />
            <Text color="#0D2439" className="title">
              {Translation.t("title.medical-team")}
            </Text>
          </div>
          <div style={{ marginTop: 16, marginBottom: 16 }}>
            <SearchInput
              placeholder="جستجو بر اساس نام یا تخصص..."
              value={externalSearchTerm}
              handleChange={(e) => onSearchChange?.(e.target.value)}
              handleSearch={() => {}}
            />
          </div>
          <div className="medical-team-container" style={containerStyle}>
            {displayMedicalTeam?.map((doctor) => (
              <MedicalTeamCard
                key={doctor._id}
                doctor={doctor}
                webConfig={webConfig}
                center={center}
              />
            ))}
            {isSearching && !displayMedicalTeam?.length && (
              <div className="no-result">
                <Text color="#6b7280">هیچ پزشکی با این تخصص پیدا نشد.</Text>
              </div>
            )}
          </div>
          {!viewMore && !isSearching && (
            <span
              className="view-more-button"
              onClick={() => setViewMore(true)}
            >
              {Translation.t("label.view-more")} <KeyboardArrowDownIcon />
            </span>
          )}
        </div>
      ) : null}
    </>
  );
};

export default MedicalTeam;
